export const buildUrlWithAmount = (url?: string | null, amount?: string): string => {
  if (!url) return '#';
  if (!url.includes('apply.lend')) return url;
  if (!amount) return url;

  const encodedAmount = encodeURIComponent(amount);
  return url.includes('?')
    ? `${url}${url.endsWith('?') || url.endsWith('&') ? '' : '&'}amount=${encodedAmount}`
    : `${url}?amount=${encodedAmount}`;
};

export const formatNumberWithCommas = (val: string): string => {
  if (!val) return '';
  const [integer, decimal] = val.split('.');
  const withCommas = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimal ? `${withCommas}.${decimal}` : withCommas;
};

export const formatCurrency = (val?: number | null): string | undefined => {
  if (typeof val !== 'number' || val <= 0) return undefined;

  if (val >= 1_000_000) return `$${(val / 1_000_000).toFixed(1).replace(/\.0$/, '')}m`;
  if (val >= 1_000) return `$${(val / 1_000).toFixed(0)}k`;

  return `$${val.toLocaleString()}`;
};

export const formatCurrencyRange = (min?: number | null, max?: number | null): string => {
  const minVal = formatCurrency(min);
  const maxVal = formatCurrency(max);

  if (minVal && maxVal) return `${minVal} – ${maxVal}`;
  if (!minVal && maxVal) return `Up to ${maxVal}`;
  if (minVal && !maxVal) return `From ${minVal}`;
  return 'Quoted on application';
};
